import React, { MouseEventHandler, ChangeEvent } from 'react';
import Box from '@mui/material/Box';
import { SelectChangeEvent } from '@mui/material/Select';
import { emptyFn } from '@core/interfaces/emptyFn';
import { BindedHandler } from '@core/interfaces/binded-handler';
import InputComponent from '@ui/components/Input/Input.component';
import useDictionary from '@ui/hooks/useDictionary';
import SwitchComponent from './Switch.component';
import SelectComponent from '@ui/components/Select/Select.component';
import { lang } from '@lang/interfaces/lang';

interface IProps {
    lang: lang;
    name: string;
    serverState: boolean;
    serverProtocol: string;
    serverAddress: string;
    serverPort: number;
    serverPassword: string;
    onServerStateChange: MouseEventHandler<HTMLElement>;
    onServerProtocolChange: BindedHandler<SelectChangeEvent<string>>;
    onServerAddressChange: BindedHandler<ChangeEvent<HTMLInputElement>>;
    onServerPortChange: BindedHandler<ChangeEvent<HTMLInputElement>>;
    onServerPasswordChange: BindedHandler<ChangeEvent<HTMLInputElement>>;
    onInputClick: emptyFn;
}

const Component: React.FC<IProps> = ({
    lang,
    name,
    serverState,
    serverProtocol,
    serverAddress,
    serverPort,
    serverPassword,
    onServerStateChange,
    onServerProtocolChange,
    onServerAddressChange,
    onServerPortChange,
    onServerPasswordChange,
    onInputClick,
}: IProps) => {
    const getWord = useDictionary();
    const protocols = ['Wialon IPS 2.0'];

    return (
        <Box className="device-settings__server-item" component="li">
            <SwitchComponent
                alarmState={serverState}
                name={name}
                tooltip={`${getWord('serverStateTooltip')} ${getWord(
                    name,
                ).toLowerCase()}`}
                onAlarmStateChange={onServerStateChange}
            />
            <SelectComponent
                label="protocol"
                name="server-protocol"
                description="serverProtocolTooltip"
                lang={lang}
                disabled={!serverState}
                value={serverProtocol}
                values={protocols}
                onChange={onServerProtocolChange.bind(this, name)}
                onClick={onInputClick}
                onFocus={onInputClick}
            />
            <InputComponent
                label="serverAddress"
                name="server-address"
                type="text"
                description="serverAddressTooltip"
                lang={lang}
                disabled={!serverState}
                value={serverAddress}
                onChange={onServerAddressChange.bind(this, name)}
                onClick={onInputClick}
                onFocus={onInputClick}
            />
            <InputComponent
                label="serverPort"
                name="server-port"
                type="number"
                description="serverPortTooltip"
                lang={lang}
                disabled={!serverState}
                numberProps={{
                    min: 0,
                    max: 65535,
                }}
                value={serverPort}
                onChange={onServerPortChange.bind(this, name)}
                onClick={onInputClick}
                onFocus={onInputClick}
            />
            <InputComponent
                label="serverPassword"
                name="server-password"
                type="text"
                lang={lang}
                description={getWord('serverPasswordTooltip')}
                disabled={!serverState}
                value={serverPassword}
                onChange={onServerPasswordChange.bind(this, name)}
                onClick={onInputClick}
                onFocus={onInputClick}
            />
        </Box>
    );
};

const ServerItemComponent = React.memo(Component);

export default ServerItemComponent;
